export default __webpack_public_path__ + "static/media/ico-k.4fb4af65.svg";